import { render, staticRenderFns } from "./1_VincularSorteio.vue?vue&type=template&id=8032f5c2&"
import script from "./1_VincularSorteio.vue?vue&type=script&lang=js&"
export * from "./1_VincularSorteio.vue?vue&type=script&lang=js&"
import style0 from "./1_VincularSorteio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports